// extracted by mini-css-extract-plugin
export default {"metricsContainer":"GrowthMetrics_metricsContainer__YjXN5"};